module.exports = __webpack_public_path__ + "static/media/data-sheet.3df83306.pdf";